export default __webpack_public_path__ + "static/banner-one-shape10-c6d5545b1939271c6e3d0b4149f86ae3.png";